import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Helpers from '../../../../common/helpers';
import commissionSchemeConstants from '../constants/commission-scheme-constants';

class CommissionSchemeIfs extends Component {
  renderParagraphs(paragraphs) {
    const { t } = this.context;

    return (
      <div>
        {paragraphs &&
          paragraphs.map((item, index) => {
            return (
              <p className="commission-scheme-ifs__content" key={index}>
                {t(item || '')}
              </p>
            );
          })}
        <a href="mailto:affiliates@naga.com">affiliates@naga.com</a>
      </div>
    );
  }

  render() {
    const { t } = this.context;
    const { profile } = this.props;
    const userType = t(Helpers.getUserType(profile));

    return (
      <div className="commission-scheme-ifs">
        <p className="commission-scheme-ifs__title">{t('COMMISSION_SCHEME.TITLE', { type: userType })}</p>
        {this.renderParagraphs(commissionSchemeConstants.ifs_schema_paragraphs)}
      </div>
    );
  }
}

CommissionSchemeIfs.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default CommissionSchemeIfs;



// WEBPACK FOOTER //
// ./src/app/main/commission-scheme/components/commission-scheme-ifs.js